// extracted by mini-css-extract-plugin
export default {"container":"style_container__V8mEp","card":"style_card__cyyLV"};